import { adminHttpClient } from "../../../commons/adminHttpClinet";
import { UserData } from "../../../models/dashboard/users/user";

const getListOfUsersByDevice = ( deviceId: string ): Promise<Array<UserData>> => {
    return adminHttpClient.get(`/api/Admin/AdminUsers/device-users?DeviceId=${deviceId}`)
}

export default getListOfUsersByDevice;